import React from 'react';
import { motion } from 'framer-motion';
import { SunriseIcon, SunIcon, MoonIcon, CookieIcon } from 'lucide-react';
export interface Meal {
  type: 'Desayuno' | 'Comida' | 'Cena' | 'Snack';
  description: string;
}
interface DayCardProps {
  dayNumber: number;
  meals: Meal[];
}
const mealIcons = {
  Desayuno: SunriseIcon,
  Comida: SunIcon,
  Cena: MoonIcon,
  Snack: CookieIcon
};
const mealColors = {
  Desayuno: 'bg-amber-50 text-amber-700 border-amber-100',
  Comida: 'bg-wellness-sage/40 text-wellness-primary border-wellness-sage',
  Cena: 'bg-indigo-50 text-indigo-700 border-indigo-100',
  Snack: 'bg-orange-50 text-wellness-accent border-orange-100'
};
export function DayCard({
  dayNumber,
  meals
}: DayCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4
  }} className="w-full" data-id="element-9">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-10">
        {meals.map((meal, index) => {
        const Icon = mealIcons[meal.type];
        const colorClass = mealColors[meal.type];
        return <motion.div key={`${dayNumber}-${meal.type}`} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: index * 0.1,
          duration: 0.3
        }} className="bg-white rounded-[1.5rem] p-6 sm:p-8 shadow-organic-sm border border-wellness-sage/30 flex flex-col h-full" data-id="element-11">
              <div className="flex items-center gap-3 mb-4" data-id="element-12">
                <div className={`p-3 rounded-xl ${colorClass}`} data-id="element-13">
                  <Icon className="w-6 h-6" data-id="element-14" />
                </div>
                <h4 className="text-xl font-serif font-semibold text-wellness-primary" data-id="element-15">
                  {meal.type}
                </h4>
              </div>

              <p className="text-wellness-text/90 text-lg leading-relaxed flex-grow" data-id="element-16">
                {meal.description}
              </p>
            </motion.div>;
      })}
      </div>
    </motion.div>;
}